// extracted by mini-css-extract-plugin
module.exports = {"Button":"G_bJ d_bJ d_bn f_dp f_dD f_ds f_gk","full":"G_tJ f_cl f_cw","width100":"G_cl f_cl","design3Pos":"G_tK f_cQ"};